import ezcaterLogo from 'images/ezcater-logo.inline.svg'

export type HireOptionKey =
  | 'catering'
  | 'dropOff'
  | 'event'
  | 'recurring'
  | 'brandActivations'
  | 'other'

export enum WizardStep {
  PaymentType = 'payment',
  ServingMethod = 'serving',
  Frequency = 'frequency'
}

export type ThemeConfig = {
  name: string
  colors: {
    primary: string
    primaryHover: string
    primaryLight: string
    primaryBorder: string
    primaryText: string
    accent: string
    accentLight: string
    button: string
    buttonHover: string
  }
  fonts: {
    heading: string
    body: string
    bodyWeight: string
  }
  borderRadius: {
    button: string
    card: string
  }
  logoUrl?: string
  page: {
    grayBackground: boolean
    fullWidth: boolean
    hideFooter: boolean
    hideCart: boolean
    themedBackground: boolean
  }
  visibleHireOptions: HireOptionKey[]
}

export const defaultTheme: ThemeConfig = {
  name: 'BFT',
  colors: {
    primary: '#ea580c',
    primaryHover: '#c2410c',
    primaryLight: '#fff7ed',
    primaryBorder: '#fed7aa',
    primaryText: '#ffffff',
    accent: '#f97316',
    accentLight: '#fff7ed',
    button: '#ea580c',
    buttonHover: '#c2410c'
  },
  fonts: {
    heading: 'var(--font-libre-franklin)',
    body: 'var(--font-roboto)',
    bodyWeight: '400'
  },
  borderRadius: {
    button: '0.375rem',
    card: '1rem'
  },
  page: {
    grayBackground: true,
    fullWidth: false,
    hideFooter: false,
    hideCart: false,
    themedBackground: false
  },
  visibleHireOptions: ['catering', 'dropOff']
}

export const themes: Record<string, ThemeConfig> = {
  ezcater: {
    name: 'ezCater',
    colors: {
      primary: 'rgb(0, 58, 48)',
      primaryHover: 'rgb(0, 45, 37)',
      primaryLight: 'rgb(228, 243, 239)',
      primaryBorder: 'rgb(128, 195, 176)',
      primaryText: '#ffffff',
      accent: '#f97316',
      accentLight: '#FFF3E0',
      button: 'rgb(0, 128, 84)',
      buttonHover: 'rgb(0, 100, 68)'
    },
    fonts: {
      heading: 'var(--font-libre-franklin)',
      body: 'var(--font-figtree)',
      bodyWeight: '400'
    },
    borderRadius: {
      button: '0.625rem',
      card: '0.75rem'
    },
    logoUrl: ezcaterLogo,
    page: {
      grayBackground: false,
      fullWidth: true,
      hideFooter: true,
      hideCart: true,
      themedBackground: true
    },
    visibleHireOptions: ['catering', 'event', 'recurring']
  }
}
